import useStyles from "../../styles";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  FormLabel,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Tooltip,
} from "@material-ui/core";
import {
  fetchExamDate,
  fetchExamByDate,
  fetchCenterByDate,
} from "../../service/services";
import { toast } from "react-toastify";
import SaveIcon from "@material-ui/icons/Save";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";

function ReportHeader({
  exportApi,
  setLoaderOpen,
  setSelectedExam,
  selectedExam,
  fetchData,
  setSelectedCenter,
  selectedCenter,
  showSave = true,
  examBase = true,
  setDate = () => {},
}) {
  const classes = useStyles();
  const navigate = useNavigate();
  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const [examDate, setExamDate] = useState([]);
  const [selectedExamDate, setSelectedExamDate] = useState("");

  const [exam, setExam] = useState([]);
  const [center, setCenter] = useState([]);

  const [fileURL, setFileURL] = useState("");

  const handleExamDateChange = (event) => {
    setSelectedExamDate(event.target.value);
    setDate(event.target.value);
    setSelectedExam("");
    setSelectedCenter && setSelectedCenter("");
  };

  const handleExamChange = (event) => {
    setSelectedExam(event.target.value);
  };
  const handleExamChange2 = (event) => {
    const {
      target: { value },
    } = event;

    setSelectedExam(typeof value === "string" ? value.split(",") : value);
  };

  // const handleCenterChange = (event) => {
  //   setSelectedCenter(event.target.value);
  // };

  const handleCenterChange = (event) => {
    const {
      target: { value },
    } = event;

    setSelectedCenter(typeof value === "string" ? value.split(",") : value);
  };

  const fetchExamDateAPi = async () => {
    try {
      const response = await fetchExamDate();
      setExamDate(response.exams);
    } catch (error) {
      console.log("Error fetching question paper:", error);
    }
  };

  useEffect(() => {
    fetchExamDateAPi();
  }, []);

  const fetchExamAPi = async () => {
    try {
      const response = await fetchExamByDate(selectedExamDate);
      setExam(response.exams);
    } catch (error) {
      console.log("Error fetching question paper:", error);
    }
  };
  const fetchCenterAPi = async () => {
    try {
      const response = await fetchCenterByDate(selectedExamDate);
      setCenter(response.centers);
    } catch (error) {
      console.log("Error fetching question paper:", error);
    }
  };

  useEffect(() => {
    if (selectedExamDate) {
      fetchExamAPi(selectedExamDate);
      fetchCenterAPi();
    }
  }, [selectedExamDate]);

  const handleExportClick = async () => {
    try {
      if (!selectedExam) {
        toast.error("Export file is not available for this.");
        return;
      }

      setLoaderOpen(true); // show loader before API call

      // ✅ use exportApi instead of Report2Api
      const response = await exportApi(selectedExam);

      if (response.success) {
        setFileURL(response.file_url);
        window.open(response.file_url, "_blank");
        toast.success("CSV has been downloaded successfully.");
      } else {
        toast.error("Failed to download the CSV file.");
      }
    } catch (error) {
      console.error("API Error:", error);
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while fetching the data.";
      toast.error(errorMessage);
    } finally {
      setLoaderOpen(false); // ✅ always close loader
    }
  };

  const handleApplyClick = async () => {
    if (!selectedExam && examBase) {
      toast.error("Please select an exam before applying.");
      return;
    }
    try {
      await fetchData(selectedExam); // ✅ call your working API
      // toast.success("Attendance successfully.");
    } catch (error) {
      console.error("Apply Error:", error);
      toast.error("Failed to fetch data.");
    }
  };

  return (
    <>
      <div
        className={`${classes.w100} ${classes.bgblue} ${classes.inputdropdowniconcolor}  ${classes.alignitemscenter}   ${classes.mt1} ${classes.borderradius6px}   ${classes.inputpadding} ${classes.inputborderwhite}  ${classes.inputplaceholdercolor}   ${classes.dflex}`}
      >
        <div className={`${classes.w100} ${classes.dflex}`}>
          <div
            className={`${classes.dflex}  ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.my1}`}
          >
            <FormLabel
              className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} 
              ${classes.lineheight}`}
            ></FormLabel>
            {/* <Select
              labelId="batch-label"
              id="examdate"
              value={selectedExamDate}
              onChange={handleExamDateChange}
              displayEmpty
              className={classes.selectEmpty}
              MenuProps={menuProps}
              variant="outlined"
            >
              <MenuItem disabled value="">
                <em className={classes.defaultselect}>Select Date</em>
              </MenuItem>
              {examDate &&
                examDate.map((st) => (
                  <MenuItem key={st.start_date} value={st.start_date}>
                    {st?.start_date}
                  </MenuItem>
                ))}
            </Select> */}
            <TextField
              type="date"
              variant="outlined"
              required
              className={`${classes.whiteCalendar}`}
              value={selectedExamDate}
              onChange={handleExamDateChange}
              placeholder="Select Date"
            />
          </div>
          {examBase && (
            <div
              className={`${classes.dflex}  ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.my1}`}
            >
              <FormLabel
                className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} 
              ${classes.lineheight}`}
              ></FormLabel>
              <Select
                labelId="category-label"
                id="state"
                value={selectedExam}
                onChange={handleExamChange}
                displayEmpty
                // className={classes.selectEmpty}
                MenuProps={menuProps}
                variant="outlined"
              >
                {console.log("exam", exam)}
                <MenuItem disabled value="">
                  <em className={classes.defaultselect}>Select Exam</em>
                </MenuItem>
                {exam?.map((data, index) => {
                  return (
                    <MenuItem value={data.id} key={index}>
                      {data.exam_code} - {data.exam_name}
                    </MenuItem>
                  );
                })}
              </Select>
            </div>
          )}

          {!examBase && (
            <>
              <div
                className={`${classes.dflex} ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.my1}`}
              >
                <Select
                  labelId="exam-label"
                  id="exam"
                  multiple
                  value={selectedExam || []}
                  onChange={handleExamChange2}
                  displayEmpty
                  MenuProps={menuProps}
                  variant="outlined"
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return (
                        <em className={classes.defaultselect}>Select Exam</em>
                      );
                    }

                    return exam
                      ?.filter((e) => selected.includes(e.id))
                      .map((e) => `${e.exam_code}`)
                      .join(", ");
                  }}
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Exam</em>
                  </MenuItem>

                  {exam?.map((data) => (
                    <MenuItem
                      key={data.id}
                      value={data.id}
                      dense
                      disableGutters
                      sx={{
                        py: 0,
                      }}
                    >
                      <Checkbox
                      size="small"
                        checked={selectedExam?.indexOf(data.id) > -1}
                        sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}
                      />
                      <ListItemText
                        primary={`${data.exam_code} - ${data.exam_name}`}
                        sx={{
                          p: 0,
                        }}
                      />
                      <p
                      style={{paddingRight:5}}
                      ></p>
                    </MenuItem>
                  ))}
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.my1}`}
              >
                <Select
                  labelId="center-label"
                  id="center"
                  multiple
                  value={Array.isArray(selectedCenter) ? selectedCenter : []}
                  onChange={handleCenterChange}
                  displayEmpty
                  MenuProps={menuProps}
                  variant="outlined"
                  renderValue={(selected) => {
                    if (!selected || selected.length === 0) {
                      return (
                        <em className={classes.defaultselect}>Select Center</em>
                      );
                    }

                    return center
                      ?.filter((c) => selected.includes(c.id))
                      .map((c) => c.center_name)
                      .join(", ");
                  }}
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Center</em>
                  </MenuItem>
                  {center?.map((data) => (
                    <MenuItem
                      key={data.id}
                      value={data.id}
                      dense
                      disableGutters
                      sx={{
                        py: 0,
                      }}
                    >
                      <Checkbox
                        size="small"
                        checked={selectedCenter?.indexOf(data.id) > -1}
                        sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}
                      />

                      <ListItemText
                        primary={data.center_name}
                        sx={{
                          p: 0,
                        }}
                      />
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </>

            // <div
            //   className={`${classes.dflex}  ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.my1}`}
            // >
            //   <FormLabel
            //     className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400}
            //   ${classes.lineheight}`}
            //   ></FormLabel>
            //   <Select
            //     labelId="category-label"
            //     id="state"
            //     value={selectedCenter}
            //     onChange={handleCenterChange}
            //     displayEmpty
            //     // className={classes.selectEmpty}
            //     MenuProps={menuProps}
            //     variant="outlined"
            //   >
            //     <MenuItem disabled value="">
            //       <em className={classes.defaultselect}>Select Center</em>
            //     </MenuItem>
            //     {center?.map((data, index) => {
            //       return (
            //         <MenuItem value={data.id} key={index}>
            //            {data.center_name}
            //         </MenuItem>
            //       );
            //     })}
            //   </Select>
            // </div>
          )}

          <Button
            variant="contained"
            color="primary"
            className={`${classes.transparentbtn} ${classes.mx0_5} ${classes.my1}`}
            onClick={handleApplyClick}
          >
            Apply
          </Button>
        </div>

        {/* <Button
          variant="contained"
          color="primary"
          className={`${classes.transparentbtn} ${classes.mx0_5}`}
          onClick={handleExportClick}
        >
          Export
        </Button> */}

        <Tooltip title="Export">
          <IconButton
            color="primary"
            className={`${classes.mx0_5}`}
            onClick={showSave && handleExportClick}
            style={{ color: "#fff" }}
          >
            {showSave && <SaveIcon fontSize="large" />}
          </IconButton>
        </Tooltip>

        <div style={{ padding: "10px" }}></div>
      </div>
    </>
  );
}
export default ReportHeader;
